class ProductScheduleSlotsResource {
  getProductScheduleSlotsData(product_id, firstDate, lastDate, id) {
    return $.ajax(`${st.GLOBALS.BACKEND_URL}p/${product_id}/product_schedule_slots.json?first_date=${firstDate}&last_date=${lastDate}&include_id=${id}`, {
      cache: false,
      headers: st.resources.defaults.headers,
    });
  }
  getProductScheduleSlotData(product_id, id) {
    return $.ajax(`${st.GLOBALS.BACKEND_URL}p/${product_id}/product_schedule_slots/${id}`, {
      cache: false,
      headers: st.resources.defaults.headers,
    });
  }

};

st.resources = st.resources || {}
const resource = st.resources.product_schedule_slots = new ProductScheduleSlotsResource()
export default resource



// WEBPACK FOOTER //
// ./app/webpack/frontend/common/resources/ProductScheduleSlotsResource.js